// PasswordField.js
import React from "react";

const PasswordField = ({
  id,
  value,
  onChange,
  onFocus,
  onBlur,
  selected,
  isPasswordHidden,
  togglePasswordVisibility,
  label,
}) => (
  <div className="mb-4 mt-8 relative">
    <div
      className={`block text-gray-400 text-sm font-bold mb-2
      ${selected || value ? "ml-0 -top-4" : "ml-3 top-2"}  
      text-left transition-all duration-300 absolute pointer-events-none `}
      htmlFor={id}
    >
      {label}
    </div>
    <input
      id={id}
      type={isPasswordHidden ? "password" : "text"}
      value={value}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      className="appearance-none border-b-2 w-full py-1 px-3 text-gray-700 outline-none focus:border-black transition"
    />
    <button
      type="button"
      className="absolute -top-1.5 end-0 p-3.5 rounded-e-md"
      onClick={togglePasswordVisibility}
    >
      {isPasswordHidden ? (
        <svg
          className="size-5 fill-gray-400 transition-transform"
          viewBox="2 2 20 20"
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="25"
        >
          <path d="M11.998 5C7.92 5 4.256 8.093 2.145 11.483a1 1 0 0 0-.001 1.034C4.256 15.907 7.92 19 11.998 19c4.143 0 7.796-3.09 9.864-6.493a1 1 0 0 0 0-1.014C19.794 8.09 16.141 5 11.998 5m8.413 7c-1.837 2.878-4.897 5.5-8.413 5.5-3.465 0-6.532-2.632-8.404-5.5 1.871-2.868 4.939-5.5 8.404-5.5 3.518 0 6.579 2.624 8.413 5.5M12 8c2.208 0 4 1.792 4 4s-1.792 4-4 4-4-1.792-4-4 1.792-4 4-4m0 1.5a2.5 2.5 0 0 0 0 5 2.5 2.5 0 0 0 0-5" />
        </svg>
      ) : (
        <svg
          className="size-5 fill-gray-400"
          clipRule="evenodd"
          fillRule="evenodd"
          strokeLinejoin="round"
          strokeMiterlimit="2"
          viewBox="2 2 20 20"
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="25"
        >
          <path
            d="m17.068 6.545 2.683-2.359A.754.754 0 0 1 21 4.751a.75.75 0 0 1-.254.562L4.247 19.815a.749.749 0 1 1-.994-1.125l2.438-2.142a16.1 16.1 0 0 1-3.547-4.027 1 1 0 0 1 0-1.034C4.256 8.092 7.919 5 11.998 5c1.815 0 3.535.593 5.07 1.547m2.319 1.829a16 16 0 0 1 2.473 3.117 1 1 0 0 1 0 1.015c-2.067 3.402-5.719 6.491-9.863 6.491a8.9 8.9 0 0 1-3.729-.849l1.246-1.097a7.2 7.2 0 0 0 2.483.446c3.516 0 6.575-2.623 8.414-5.5a14.7 14.7 0 0 0-2.144-2.637zm-3.434 3.02q.044.296.047.604a4 4 0 0 1-5.108 3.843l1.58-1.388a2.5 2.5 0 0 0 1.902-1.671zm-.058-3.817c-1.197-.67-2.513-1.078-3.899-1.078-3.465 0-6.533 2.632-8.405 5.5.854 1.309 1.955 2.567 3.232 3.549l1.729-1.519a4.002 4.002 0 0 1 5.901-5.188zm-2.599 2.284a2.499 2.499 0 0 0-3.584 3.15z"
            fillRule="nonzero"
          />
        </svg>
      )}
    </button>
  </div>
);

export default PasswordField;
